module.exports = __webpack_public_path__ + "img/mp2.11bb6a94.png";